var map = {
	"./April.png": 1575,
	"./Artist1.jpeg": 1278,
	"./Artist2.jpeg": 859,
	"./Artist3.jpeg": 8116,
	"./Artist4.jpeg": 1889,
	"./Bhupen.jpg": 1635,
	"./ChiefEditor.jpeg": 7276,
	"./Editor.jpeg": 685,
	"./February.png": 8969,
	"./Gallery1.jpg": 9152,
	"./Gallery2.webp": 5692,
	"./Gallery3.webp": 7231,
	"./Innaguration/new.jpeg": 2676,
	"./Innaguration/new2.jpeg": 3878,
	"./Innaguration/new3.jpeg": 5213,
	"./January.png": 7781,
	"./Magazine_Release/WhatsApp Image 2025-09-28 at 12.51.28 PM.jpeg": 6915,
	"./Magazine_Release/WhatsApp Image 2025-09-28 at 12.51.29 PM (1).jpeg": 6168,
	"./Magazine_Release/WhatsApp Image 2025-09-28 at 12.51.29 PM.jpeg": 2606,
	"./Magazine_Release/WhatsApp Image 2025-09-28 at 12.51.40 PM.jpeg": 6833,
	"./March.png": 6914,
	"./May.png": 2552,
	"./Profile1.jpg": 9239,
	"./Theatre.jpg": 6126,
	"./Vision.jpg": 5219,
	"./WhatsApp Image 2025-06-16 at 6.31.04 PM (2).jpeg": 9082,
	"./about.jpg": 8296,
	"./art.jpg": 4712,
	"./art.png": 4172,
	"./art22.png": 508,
	"./art33.png": 9058,
	"./art44-.png": 7171,
	"./contact.jpg": 1103,
	"./japi.png": 3053,
	"./japi2.png": 6107,
	"./khagen.jpg": 4943,
	"./poster.jpg": 5896,
	"./publish.jpg": 2230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;